import {FC} from 'react';
import {ListItemButton} from '@mui/material';
import EnsurePermission from '../common/EnsurePermission';
import NavBarSubmenuItem from './NavBarSubmenuItem';
import LinkRenderer from './LinkRenderer';
import {ListItemProps} from './types';
import {useAppSelector} from '../../store/hooks';

export interface NavRoute {
  label: string;
  route?: string;
  exact?: boolean;
  submenu?: ListItemProps[];
  permissions: Nullable<string[]>;
  isExternal?: boolean;
  externalUrl?: string;
}

interface NavigationProps extends NavRoute {
  closeDrawer: () => void,
}

const NavBarItem: FC<NavigationProps> = (({
  label, route, submenu, permissions, closeDrawer,
  exact, isExternal, externalUrl
}) => {
  const {activeTenant} = useAppSelector((state) => state.permissions);

  if (!activeTenant) {
    return null;
  }

  if (submenu?.length) {
    return (
      <NavBarSubmenuItem
        submenu={submenu}
        label={label}
        permissions={permissions}
        closeDrawer={closeDrawer}
      />
    );
  }

  if (isExternal && externalUrl) {
    return (
      <EnsurePermission elementPermissions={permissions}>
        <ListItemButton className="list-item-button" onClick={closeDrawer}>
          <a
            className="link"
            href={externalUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            {label}
          </a>
        </ListItemButton>
      </EnsurePermission>
    );
  }

  return (
    <EnsurePermission elementPermissions={permissions}>
      <ListItemButton className="list-item-button">
        <LinkRenderer
          label={label}
          route={route}
          closeDrawer={closeDrawer}
          exact={exact}
        />
      </ListItemButton>
    </EnsurePermission>
  );
});

export default NavBarItem;
